/**
 * GoogleCalendarGateway の Supabase 実装（Edge Function google-calendar-sync）。
 */
import { supabase } from "@/integrations/supabase/client";
import type { GoogleCalendarGateway } from "@/domain/repositoryInterface/GoogleCalendarGateway";

const FUNCTION = "google-calendar-sync";

export class SupabaseGoogleCalendarGateway implements GoogleCalendarGateway {
  async getConnectionStatus(shopId: string): Promise<boolean> {
    const { data } = await supabase.functions.invoke(FUNCTION, {
      body: { action: "status", shop_id: shopId },
    });
    return !!data?.connected;
  }

  async syncEvent(bookingId: string, shopId: string): Promise<void> {
    const { error } = await supabase.functions.invoke(FUNCTION, {
      body: { action: "sync_event", booking_id: bookingId, shop_id: shopId },
    });
    if (error) throw error;
  }

  async deleteEvent(bookingId: string, shopId: string): Promise<void> {
    const { error } = await supabase.functions.invoke(FUNCTION, {
      body: { action: "delete_event", booking_id: bookingId, shop_id: shopId },
    });
    if (error) throw error;
  }
}
